module.exports = __webpack_public_path__ + "static/img/ARCHIE-HILL.05c7d3a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ARCHIE-HILL.jpg
// module id = QPiR
// module chunks = 0